import React from 'react';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';

import type { IContainerHeading } from './types';
import { RELINKING_VARIANTS } from '../../constants';

export const ContainerHeading = (props: IContainerHeading) => {
  const { variant, isMobile, title } = props;
  const { t } = useTranslation();

  const isHotelsVariant = variant === RELINKING_VARIANTS.HOTELS;
  const isCountriesVariant =
    variant === RELINKING_VARIANTS.DEFAULT_COUNTRIES ||
    variant === RELINKING_VARIANTS.COUNTRIES_WITH_PRICES;

  const headingText =
    title ??
    t('homeRelinking.heading', {
      context: isCountriesVariant ? 'countries' : variant,
    });

  return (
    <>
      <StyledHeader $isMobile={isMobile}>
        <StyledHeading $isMobile={isMobile} $isHotelsVariant={isHotelsVariant}>
          {headingText}
        </StyledHeading>
      </StyledHeader>
    </>
  );
};

const StyledHeader = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  align-items: ${({ $isMobile }) => ($isMobile ? 'flex-start' : 'center')};
`;

const StyledHeading = styled.div<{
  $isMobile: boolean;
  $isHotelsVariant: boolean;
}>`
  font-size: 24px;
  line-height: 33px;
  color: black;

  margin: ${({ $isHotelsVariant, $isMobile }) => {
    let marginBottom = 20;

    if ($isHotelsVariant) {
      marginBottom = $isMobile ? 8 : 14;
    }

    return `20px 0 ${marginBottom}px`;
  }};

  ${({ $isMobile }) => $isMobile && 'margin-left: 8px;'}
`;
